import React, { useState, useEffect } from "react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { DashBoard } from "../../../components/Admin/Dashboard/Dashboard/DashBoard";
import { useLanguage, useSite } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";

const permissionController = new Permission();

export function Dashboard() {
  const { translations } = useLanguage();

    const {
      accessToken,
      user: { role },
    } = useAuth();

  const t = (key) => translations[key] || key; // Función para obtener la traducción
  const [siteSelected, setSiteSelected] = useState(null);
  const [companySelected, setCompanySelected] = useState(null);

   const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { site } = useSite();
  const { company } = useCompany();

  useEffect(() => {
    (async () => {
      setCompanySelected(company);
      setSiteSelected("");
    })();
  }, [company]);

  useEffect(() => {
    (async () => {
      setSiteSelected(site);
    })();
  }, [site]);

    useEffect(() => {
      (async () => {
        try {
          setPermissionsByRole([]);
          if (role) {
            const response = await permissionController.getPermissionsByRole(
              accessToken,
              role._id,
              true
            );
            setPermissionsByRole(response);
          }
        } catch (error) {
          console.error(error);
          setPermissionsByRole([]);
        }
      })();
    }, [role]);

   if (
    isMaster(role) || isAdmin(role) ||
    (role && hasPermission(permissionsByRole, role._id, "dashboard", "view"))
  ) {
  return (
    <>
      <DashBoard
        siteSelected={siteSelected}
        companySelected={companySelected}
      />
    </>
  );
  } else {
    return <ErrorAccessDenied />;
  }

  

}
